import React, { useState } from "react";
import SlidingTab from "../../../../../components/SlidingTab/SlidingTab";
import Chargebacks from "./Chargebacks";
import Retrieval from "./Retrieval/Index";
import Documents from "./Documents/Index";
import style from "./ChargebackTabs.module.scss";
import RebuttalProcess from "./RebuttalProcess/Index";

function ChargebackTabs() {
  const [selectedTab, setSelectedTab] = useState("Chargeback");

  const tab_options = [
    "Chargeback",
    "Retrieval",
    "Rebuttal Process",
    "Documents",
  ];

  return (
    <div className={style.tabs_container}>
      <SlidingTab
        options={tab_options}
        onChange={(tab) => setSelectedTab(tab)}
      />

      <div>
        {selectedTab === "Chargeback" && <Chargebacks />}

        {selectedTab === "Retrieval" && <Retrieval />}

        {selectedTab === "Documents" && <Documents />}

        {selectedTab === "Rebuttal Process" && <RebuttalProcess />}
      </div>
    </div>
  );
}

export default ChargebackTabs;
